var React = require('react');

function ArrowGreyRight (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M53.096 67.647a.805.805 0 0 0 .556-1.386L34.965 48.323l18.687-17.937a.805.805 0 0 0-1.113-1.162L33.248 47.743a.805.805 0 0 0 0 1.161l19.291 18.52c.157.148.357.223.557.223z"}));
}

ArrowGreyRight.displayName = "ArrowGreyRight";

ArrowGreyRight.defaultProps = {"viewBox":"33 29 21 39"};

module.exports = ArrowGreyRight;

ArrowGreyRight.default = ArrowGreyRight;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/arrow-grey-right.svg
// module id = 1250
// module chunks = 0